import { render } from "./userAdd.vue?vue&type=template&id=6ad487ba&scoped=true"
import script from "./userAdd.vue?vue&type=script&lang=js"
export * from "./userAdd.vue?vue&type=script&lang=js"

import "./userAdd.vue?vue&type=style&index=0&id=6ad487ba&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\shilina\\Desktop\\后台\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad487ba"]])

export default __exports__